var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-banner"},[_c('img',{staticClass:"img",attrs:{"src":require("../asset/component/banner/banner.png"),"alt":""}})])
}]

export { render, staticRenderFns }